export const SET_WEERDS = "SET_WEERDS";
export const ADD_WEERD = "ADD_WEERD";
export const EDIT_WEERD = "EDIT_WEERD";
export const REMOVE_WEERD = "REMOVE_WEERD";
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const GET_WEERD = "GET_WEERD";
export const SET_MY_WEERDS = "SET_MY_WEERDS";